import React from "react";

import "./aux-menu.css";

interface IAuxMenuProps {
    isOpen: boolean;
    title?: string;
    onRequestClose: () => void;
}

class AuxMenu extends React.Component<IAuxMenuProps> {
    constructor(props: Readonly<IAuxMenuProps>) {
        super(props);

        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    public render() {
        return <div className={`aux-menu-outer ${this.props.isOpen ? "aux-menu-open" : ""}`}>
            <div className="aux-menu-scrim" onClick={this.handleCloseClick} />
            <div className="aux-menu">
                <header>
                    <span>{this.props.title || ""}</span>
                    <button type="button" className="btn-hide icon-times" title="Close" onClick={this.handleCloseClick} />
                </header>
                {this.props.children}
            </div>
        </div>;
    }

    private handleCloseClick() {
        if (this.props.onRequestClose) {
            this.props.onRequestClose();
        }
    }
}

export default AuxMenu;
